import React from "react";
import mapboxgl from 'mapbox-gl';

// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import ReactTooltip from 'react-tooltip';

import Header from "components/Header/Header.js";
import Footer from "components/SiteFooter/Footer.js";
import HeaderLinks from "components/SiteHeader/HeaderLinks.js";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CircularProgress from '@material-ui/core/CircularProgress';
import { municipality_data_all } from 'assets/map_data/selected_municipalities.js'
import { district_data } from 'assets/map_data/bhaktapur_district.js'
import { district_data_school } from 'assets/map_data/bhaktapur_district_school.js'
import * as turf from '@turf/turf'

import styles from "assets/jss/material-kit-react/views/landingPage.js";
import { API_BASE_URL } from "views/api"

// Sections for this page
import ProjectInsight from "views/MainPage/Sections/Project.js";
// import Municipality from "views/MainPage/Sections/Municipality.js";
import Brand from "../Brand.js";
import './styles.css'
//for download icon
import GetAppIcon from '@material-ui/icons/GetApp';
import IconButton from '@material-ui/core/IconButton';
import ButtonMI from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import Pagination from '@material-ui/lab/Pagination';
import Truncate from 'react-truncate';
const dashboardRoutes = [];
const useStyles = makeStyles(styles);
const mapConfig = {
  accessToken:
    'pk.eyJ1IjoiYXJqdW5nYXV0YW0iLCJhIjoiY2pxM3VmbG4yMGMyZjQybzU1aW9hcWY3eiJ9.KEW4wlm1BULoqV_uyahTjQ',
  mapStyle: 'mapbox://styles/mapbox/light-v9',
  minZoom: 3,
  maxZoom: 16,
  zoomLevel: 11,
  center: [85.4281287, 27.6720287],
  attribution: '',
  // fullscreenQuerySelector: '#map',
  fullscreenQuerySelector: '#fullscreen_cover',
  // fullscreenQuerySelector: '#main_page',78.277588,24.547476,90.461426,31.503960
  maxBounds: [[76.277588, 24.547476], [92.461426, 31.50396]],
};
let mapContainer = () => { }

let universalMap;

const updateMap = (display_content, props, selected_district_data) => {
  try {
    universalMap.removeLayer('area_fill_district');
    universalMap.removeLayer('area_boundaries_district');

    universalMap.removeSource('area_fill_district');
    universalMap.removeSource('area_boundaries_district');

    universalMap.removeLayer('clusters')
    universalMap.removeLayer('cluster-count')
    universalMap.removeLayer('unclustered-point')

    universalMap.removeSource('map_data')

    universalMap.addSource('map_data', {
      type: 'geojson',
      data: display_content,
      cluster: true,
      clusterMaxZoom: 14, // Max zoom to cluster points on
      clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
    });
    universalMap.addLayer({
      id: 'clusters',
      type: 'circle',
      source: 'map_data',
      filter: ['has', 'point_count'],
      paint: {
        'circle-color': ['step', ['get', 'point_count'], '#51bbd6', 100, '#f1f075', 750, '#f28cb1'],
        'circle-radius': ['step', ['get', 'point_count'], 20, 100, 30, 750, 40]
      }
    });

    universalMap.addLayer({
      id: 'cluster-count',
      type: 'symbol',
      source: 'map_data',
      filter: ['has', 'point_count'],
      layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12
      }
    });

    universalMap.addLayer({
      id: 'unclustered-point',
      type: 'symbol',
      source: 'map_data',
      filter: ['!', ['has', 'point_count']],
      "layout": {
        "icon-image": "marker-15",
        "icon-size": 1.5,
      }
    }
    );

    universalMap.addSource('area_fill_district', {
      type: 'geojson',
      data: selected_district_data,
    });
    universalMap.addSource('area_boundaries_district', {
      type: 'geojson',
      data: selected_district_data,
    });
    universalMap.addLayer({
      'id': 'area_fill_district',
      'type': 'fill',
      'source': 'area_fill_district',
      'layout': {},
      'paint': {
        'fill-color': 'black',
        'fill-opacity': 0.2,
      },
    });
    universalMap.addLayer({
      'id': 'area_boundaries_district',
      'type': 'line',
      'source': 'area_boundaries_district',
      'layout': {},
      'paint': {
        'line-color': '#134c7a',
        'line-width': 1,
      },
    });
    var bounds = turf.bbox(selected_district_data);
    universalMap.fitBounds(bounds, { padding: 50 });

  } catch (e) {
    console.log(e);
  }
  // universalMap.removeSource('area_fill_district')
  // universalMap.removeSource('area_boundaries_district')
  // universalMap.removeSource('map_data')
}

const loadMap = (display_content, props, selected_district_data) => {
  // GETTING MAP READY
  mapboxgl.accessToken = mapConfig.accessToken;
  const map = new mapboxgl.Map({
    attributionControl: false,
    container: mapContainer,
    style: mapConfig.mapStyle,
    center: mapConfig.center,
    zoom: mapConfig.zoomLevel,
    maxZoom: mapConfig.maxZoom,
    minZoom: mapConfig.minZoom,
    maxBounds: mapConfig.maxBounds,
  })
    .addControl(
      new mapboxgl.AttributionControl({
        compact: true,
        customAttribution: mapConfig.attribution,
      }),
    )
    .addControl(new mapboxgl.NavigationControl(), 'top-left');

    universalMap = map

  map.on('load', () => {

    map.addSource('area_fill_district', {
      type: 'geojson',
      data: selected_district_data,
    });
    map.addSource('area_boundaries_district', {
      type: 'geojson',
      data: selected_district_data,
    });
    map.addLayer({
      'id': 'area_fill_district',
      'type': 'fill',
      'source': 'area_fill_district',
      'layout': {},
      'paint': {
        'fill-color': 'black',
        'fill-opacity': 0.2,
      },
    });
    map.addLayer({
      'id': 'area_boundaries_district',
      'type': 'line',
      'source': 'area_boundaries_district',
      'layout': {},
      'paint': {
        'line-color': '#134c7a',
        'line-width': 1,
      },
    });


    map.addSource('map_data', {
      type: 'geojson',
      data: display_content,
      cluster: true,
      clusterMaxZoom: 14, // Max zoom to cluster points on
      clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
    });
    map.addLayer({
      id: 'clusters',
      type: 'circle',
      source: 'map_data',
      filter: ['has', 'point_count'],
      paint: {
        'circle-color': ['step', ['get', 'point_count'], '#51bbd6', 100, '#f1f075', 750, '#f28cb1'],
        'circle-radius': ['step', ['get', 'point_count'], 20, 100, 30, 750, 40]
      }
    });

    map.addLayer({
      id: 'cluster-count',
      type: 'symbol',
      source: 'map_data',
      filter: ['has', 'point_count'],
      layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12
      }
    });

    map.addLayer({
      id: 'unclustered-point',
      type: 'symbol',
      source: 'map_data',
      filter: ['!', ['has', 'point_count']],
      "layout": {
        "icon-image": "marker-15",
        "icon-size": 1.5,
      }
    }
    );

    map.on('click', 'clusters', function (e) {
      var features = map.queryRenderedFeatures(e.point, {
        layers: ['clusters']
      });
      var clusterId = features[0].properties.cluster_id;
      map.getSource('map_data').getClusterExpansionZoom(
        clusterId,
        function (err, zoom) {
          if (err) return;
          map.easeTo({
            center: features[0].geometry.coordinates,
            zoom: zoom
          });
        }
      );
    });
    let _popup = new mapboxgl.Popup()


    map.on('mouseenter', 'unclustered-point', function (e) {
      var coordinates = e.features[0].geometry.coordinates.slice();
      var { name, budget, ward_info, additional_info } = e.features[0].properties;
      if (name === undefined) {
        name = e.features[0].properties['name:en'];
      }
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }
      _popup
        .setLngLat(coordinates)
        .setHTML(
          '<div style="font-family: nepali-font">' +
          '<div>योजना: ' + name + '</div>' +
          '<div>' + additional_info + '</div>' +
          '<div>जम्मा बजेट: रु. ' + budget + '</div>' +
          '<div>' + ward_info + '</div>' +
          '</div>'
        )
        .addTo(map);
    });

    map.on('mouseenter', 'clusters', function () {
      map.getCanvas().style.cursor = 'pointer';
    });
    map.on('mouseleave', 'clusters', function () {
      map.getCanvas().style.cursor = '';
    });
    map.on('mouseenter', 'unclustered-point', function (e) {
      map.getCanvas().style.cursor = 'pointer';
    });
    map.on('mouseleave', 'unclustered-point', function (e) {
      map.getCanvas().style.cursor = '';
      _popup.remove();
    });

    var bounds = turf.bbox(selected_district_data);
    map.fitBounds(bounds, { padding: 50 });

  });

  // DISABLE ZOOM ON SCROLL
  map.scrollZoom.disable();
  // this.map = map;
};

const OFFICE_API_MAP = {
  'districtOffice': 'bhaktapur_district',
  'changunarayanMunicipality': 'changunarayan',
  'bhaktapurMunicipality': 'bhaktapur',
  'madhyapurThimiMunicipality': 'madhyapur_thimi',
  'suryabinayakMunicipality': 'suryabinayak',
}

const ADMIN_MAP = {
  'bhaktapur_district': 'जिल्ला समन्वय समिति भक्तपुर',
  'changunarayan': 'चाँगुनारायण नगरपालिका',
  'bhaktapur': 'भक्तपुर नगरपालिका',
  'madhyapur_thimi': 'मध्यपुर थिमि नगरपालिका',
  'suryabinayak': 'सूर्यविनायक नगरपालिका',
}

const MUNICIPALITY_PROJECT_CATEGORY_MAP = {
  'agriculture': 'कृषि',
  'industry_and_commerce': 'उद्योग तथा वाणिज्य',
  'touristic': 'पर्यटन',
  'cooperative': 'सहकारी',
  'financial_sector': 'वित्तीय क्षेत्र',
  'education': 'शिक्षा',
  'health': 'स्वास्थ्य',
  'drinking_water_cleanliness': 'खानेपानी तथा सरसफाइ',
  'cultural_promotion': 'संस्कृति प्रवर्द्धन',
  'sports_and_recreation': 'खेलकुद तथा मनोरञ्जन',
  'gender_equality_social_inclusion': 'लै‌गिक समानता तथा सामाजिक समावेशीकरण',
  'road_bridge': 'स्थानीय सडक, पुल तथा झोलुङ्गेपुल',
  'irrigation': 'सिंचाई',
  'building_and_urban_development': 'भवन तथा सहरी विकास',
  'alternative_energy': 'उर्जा, लघु तथा साना जलविद्युत (वैकल्पिक उर्जा समेत)',
  'communication': 'सञ्चार',
  'forest_and_soil_conservation': 'वन तथा भु-संरक्षण',
  'watershed_protection': 'जलाधार संरक्षण',
  'environment_protection_and_climate_change': 'वातावरण संरक्षण, जलवायु परिवर्तन',
  'garbage_and_sewage_protection': 'वातावरण संरक्षण, जलवायु परिवर्तन',
  'waterborne_outbreack_control': 'जलउत्पन्न प्रकोप नियन्त्रण',
  'disaster_management': 'विपद व्यवस्थापन',
  'fire_fighting': 'वारुण यन्त्र सञ्चालन',
  'general_service': 'सामान्य सेवा',
  'security_management': 'सुरक्षा व्यवस्थापन',
  'information_technology': 'सूचना प्रविधि',
  'registration_service': 'पञ्जिकरण व्यवस्थापन',
  'data_collection_and_management': 'स्थानीय तथ्याङ्क संकलन र अभिलेख व्यवस्थापन',
  'promotion_of_good_governance': 'सुशासन प्रवर्द्धन',
  'research_and_development': 'अनुसन्धान तथा विकास',
  'not_clasified': 'अन्यत्र वर्गिकृत नभएको',
  'other': 'अन्य योजना',
}

const nameMap = {
  'districtOffice': 'जिल्ला समन्वय समिति भक्तपुर',
  'changunarayanMunicipality': 'चाँगुनारायण नगरपालिका',
  'bhaktapurMunicipality': 'भक्तपुर नगरपालिका',
  'madhyapurThimiMunicipality': 'मध्यपुर थिमि नगरपालिका',
  'suryabinayakMunicipality': 'सूर्यविनायक नगरपालिका',
}
const nameMapList = [
  { name: 'जिल्ला समन्वय समिति भक्तपुर', value: 'districtOffice' },
  { name: 'चाँगुनारायण नगरपालिका', value: 'changunarayanMunicipality' },
  { name: 'भक्तपुर नगरपालिका', value: 'bhaktapurMunicipality' },
  { name: 'मध्यपुर थिमि नगरपालिका', value: 'madhyapurThimiMunicipality' },
  { name: 'सूर्यविनायक नगरपालिका', value: 'suryabinayakMunicipality' }
]

const wardsMap = {
  '*': 'सबै',
  '1': 'वडा 1',
  '2': 'वडा 2',
  '3': 'वडा 3',
  '4': 'वडा 4',
  '5': 'वडा 5',
  '6': 'वडा 6',
  '7': 'वडा 7',
  '8': 'वडा 8',
  '9': 'वडा 9',
  '10': 'वडा 10',
}
const wardsMapList = [
  { name: 'सबै', value: '*' },
  { name: 'वडा 1', value: '1' },
  { name: 'वडा 2', value: '2' },
  { name: 'वडा 3', value: '3' },
  { name: 'वडा 4', value: '4' },
  { name: 'वडा 5', value: '5' },
  { name: 'वडा 6', value: '6' },
  { name: 'वडा 7', value: '7' },
  { name: 'वडा 8', value: '8' },
  { name: 'वडा 9', value: '9' },
  { name: 'वडा 10', value: '10' },
]


const projectTypeMap = {
  '10': 'आर्थिक विकास',
  '20': 'सामाजिक विकास',
  '30': 'पूर्वाधार विकास',
  '40': 'वातावरण तथा विपद व्यवस्थापन',
  '50': 'संस्थागत विकास, सेवा प्रवाह र सुशासन',
  '60': 'अन्य योजनाहरु',
}
const projectTypeMapList = [
  { name: 'आर्थिक विकास', value: '10' },
  { name: 'सामाजिक विकास', value: '20' },
  { name: 'पूर्वाधार विकास', value: '30' },
  { name: 'वातावरण तथा विपद व्यवस्थापन', value: '40' },
  { name: 'संस्थागत विकास, सेवा प्रवाह र सुशासन', value: '50' },
  { name: 'अन्य योजनाहरु', value: '60' },
]
const projectTypeMap_api = {
  '10': 'financial-development',
  '20': 'social-development',
  '30': 'infrastructure-development',
  '40': 'environment-and-disaster-management',
  '50': 'institutional-development-service-delivery-good-governance',
  '60': 'other-municipality_projects',
}
const projectTypeMapDCC = {
  '1': 'स्थानीय पूर्वाधार विकास साझेदारी कार्यक्रम',
  '2': 'प्रदेश पूर्वाधार विकास साझेदारी कार्यक्रम',
  '3': 'जी स स मौज्दात कोष तर्फका',
  '4': 'अन्य',
}
const projectTypeMapDCC_api = {
  '1': 'local-infrastructure-development-partnership-program',
  '2': 'state-infrastructure-development-partnership-program',
  '3': 'DCC-reserve-fund',
  '4': 'other',
}
const projectTypeMapListDCC = [
  { name: 'स्थानीय पूर्वाधार विकास साझेदारी कार्यक्रम', value: '1' },
  { name: 'प्रदेश पूर्वाधार विकास साझेदारी कार्यक्रम', value: '2' },
  { name: 'जी स स मौज्दात कोष तर्फका', value: '3' },
  { name: 'अन्य', value: '4' },
]
const FISCAL_YEAR_STRING = {
  undefined: '----/--',
  '1': '2075/76',
  '2': '2076/77',
  '3': '2077/78',
  '4': '2078/79',
  '5': '2079/80',
  '6': '2080/81',
  '7': '2081/82',
  '8': '2082/83',
  '9': '2083/84',
  '10': '2084/85'
}

const getGeoJson = (geo_coordinates, office) => {
  const geo_collection = geo_coordinates.map(geo_coordinate => {

    var ward_info = (office === 'districtOffice' || geo_coordinate.ward === '') ? "" : `वडा नं.: ${wardsMap[geo_coordinate.ward]}`;

    var additional_info = (office === 'districtOffice') ? `प्रतिनिधि: ${geo_coordinate.category}` : `"${MUNICIPALITY_PROJECT_CATEGORY_MAP[geo_coordinate.category]}" संग सम्बन्धित योजना`;

    if (geo_coordinate.location_latitude === "") return ({})
    else return ({
      "type": "Feature",
      "id": "node/1489545888",
      "properties": {
        "name": geo_coordinate.title,
        "id": "node/1489545888",
        "budget": office === 'districtOffice' ? geo_coordinate.budget_amount : geo_coordinate.amount,
        ward_info,
        additional_info
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          geo_coordinate.location_longitude,
          geo_coordinate.location_latitude
        ]
      }
    })
  })
  const geo_data = {
    "type": "FeatureCollection",
    "features": geo_collection
  }

  return geo_data
}


export default function LandingPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  const [map_active, setMapActive] = React.useState(false);
  const [office, setOffice] = React.useState('districtOffice');
  const [ward, setWard] = React.useState('*');
  const [fiscal_year, setFiscalYear] = React.useState(undefined);
  const [projectType, setProjectType] = React.useState('10');
  const [projectTypeDCC, setProjectTypeDCC] = React.useState('1');
  const [choosenDisplay, setChoosenDisplay] = React.useState('map');
  const [loading, setLoading] = React.useState(false);
  const [project_data, setProjectData] = React.useState(undefined);
  const [project_file, setProjectFile] = React.useState(undefined);

  const [has_ever_hit_api, setHasEverHitAPI] = React.useState(false);

  const [localInfrastructureDevelopmentPartnershipProgram, setLocalInfrastructureDevelopmentPartnershipProgram] = React.useState(undefined)
  const [stateInfrastructureDevelopmentPartnershipProgram, setStateInfrastructureDevelopmentPartnershipProgram] = React.useState(undefined)
  const [dccReserveFund, setDCCReserveFund] = React.useState(undefined)
  const [other, setOther] = React.useState(undefined)

  const [financialDevelopment, setFinancialDevelopment] = React.useState(undefined)
  const [socialDevelopment, setSocialDevelopment] = React.useState(undefined)
  const [infrastructureDevelopment, setInfrastructureDevelopment] = React.useState(undefined)
  const [environmentAndDisasterManagement, setEnvironmentAndDisasterManagement] = React.useState(undefined)
  const [institutionalDevelopmentServiceDeliveryGoodGovernance, setInstitutionalDevelopmentServiceDeliveryGoodGovernance] = React.useState(undefined)
  const [otherMunicipalityProjects, setOtherMunicipalityProjects] = React.useState(undefined)
  const [page, setPage] = React.useState(1);

  // React.useEffect(() => {
  //   window.scrollTo(0, 0)
  // });

  const cleanAndAdd = (array) => {
    const cleanArray = array.filter(i => i);
    if (cleanArray.length === 0) {
      return 0
    }
    if (cleanArray.length === 1) {
      return cleanArray[0]
    }
    return cleanArray.reduce((a, b) => parseInt(a) + parseInt(b))
  }

  const createAndHit = (office, ward, fiscal_year, projectType, projectTypeDCC, is_main_call) => {
    let api_url;
    setPage(1)
    setFinancialDevelopment(undefined);
    setProjectFile(undefined)
    setSocialDevelopment(undefined);
    setInfrastructureDevelopment(undefined);
    setEnvironmentAndDisasterManagement(undefined);
    setInstitutionalDevelopmentServiceDeliveryGoodGovernance(undefined);
    setOtherMunicipalityProjects(undefined);

    setLocalInfrastructureDevelopmentPartnershipProgram(undefined);
    setStateInfrastructureDevelopmentPartnershipProgram(undefined);
    setDCCReserveFund(undefined);
    setOther(undefined);

    setLoading(true);

    api_url = API_BASE_URL
    let file_url = API_BASE_URL + 'project/project-files/';

    if (projectType === undefined && projectTypeDCC === undefined) {
      api_url = api_url + 'project/'
    }
    else if (office === 'districtOffice') {
      api_url = api_url + 'project/' + projectTypeMapDCC_api[projectTypeDCC] + '/'
      if (fiscal_year) {
        api_url = api_url + '?fiscal_year=' + fiscal_year
        file_url = file_url + '?fiscal_year=' + fiscal_year + '&administrative_unit=' + OFFICE_API_MAP[office]
      }
    } else {
      api_url = api_url + 'project/' + projectTypeMap_api[projectType] + '/'
      if (fiscal_year) {
        api_url = api_url + '?fiscal_year=' + fiscal_year
        file_url = file_url + '?fiscal_year=' + fiscal_year + '&administrative_unit=' + OFFICE_API_MAP[office]
        if (ward !== '*') {
          api_url = api_url + '&ward=' + ward
        }
        api_url = api_url + '&administrative_unit=' + OFFICE_API_MAP[office]
      } else if (ward) {
        if (ward !== '*') {
          api_url = api_url + '?ward=' + ward
          api_url = api_url + '&administrative_unit=' + OFFICE_API_MAP[office]
          file_url = file_url + '?fiscal_year=' + fiscal_year + '&administrative_unit=' + OFFICE_API_MAP[office]
        }
      }
    }

    if (is_main_call) {
      setProjectData(undefined);
      fetch(api_url)
        .then(results => results.json())
        .then(data => {
          setLoading(false);
          setProjectData(data.results);
          getMap(office, data.results, false)
        });
        console.log(file_url);
      fetch(file_url)
        .then(results => results.json())
        .then(data => {
          setLoading(false);
          setProjectFile(data.results)
        });
    }
    else {
      let fiscal_list = []
      fetch(api_url)
        .then(results => results.json())
        .then(data => {
          setLoading(false);
          if (data) {
            Object.keys(data).map(data_categ => {
              fetch(data[data_categ])
                .then(results => results.json())
                .then(data => {
                  const new_fetched_fiscal_year = [...new Set(data.results.map(project_unit => project_unit.fiscal_year).filter(x => x))]
                  fiscal_list = [...new Set([...new_fetched_fiscal_year, ...fiscal_list])]
                  if (fiscal_list.length > 0) {
                    setHasEverHitAPI(true);
                    setFiscalYear(Math.max.apply(Math, fiscal_list))
                  }
                });
            })
          }
        });
      setHasEverHitAPI(true);
    }

  }

  const getMap = (office, map_project_data, first_load) => {
    const map_display_data = (map_project_data && map_project_data.length > 0) ? map_project_data : [];
    if (first_load) {
      if (office === 'districtOffice') loadMap(getGeoJson(map_display_data, office), props, district_data)
      if (office === 'changunarayanMunicipality') loadMap(getGeoJson(map_display_data, office), props, municipality_data_all.selected_municipalities_data.features[2])
      if (office === 'bhaktapurMunicipality') loadMap(getGeoJson(map_display_data, office), props, municipality_data_all.selected_municipalities_data.features[0])
      if (office === 'madhyapurThimiMunicipality') loadMap(getGeoJson(map_display_data, office), props, municipality_data_all.selected_municipalities_data.features[1])
      if (office === 'suryabinayakMunicipality') loadMap(getGeoJson(map_display_data, office), props, municipality_data_all.selected_municipalities_data.features[3])
    } else {
      if (office === 'districtOffice') updateMap(getGeoJson(map_display_data, office), props, district_data)
      if (office === 'changunarayanMunicipality') updateMap(getGeoJson(map_display_data, office), props, municipality_data_all.selected_municipalities_data.features[2])
      if (office === 'bhaktapurMunicipality') updateMap(getGeoJson(map_display_data, office), props, municipality_data_all.selected_municipalities_data.features[0])
      if (office === 'madhyapurThimiMunicipality') updateMap(getGeoJson(map_display_data, office), props, municipality_data_all.selected_municipalities_data.features[1])
      if (office === 'suryabinayakMunicipality') updateMap(getGeoJson(map_display_data, office), props, municipality_data_all.selected_municipalities_data.features[3])
    }
  }

  React.useEffect(() => {
    setMapActive(true)
    if (map_active === false) {
      getMap(office, [], true);
      // loadMap(getGeoJson([''], office), props, district_data);
    }
  }, [map_active, props]);

  // const selectedMunicipality = props.match.params.municipality
  const officeSelected = (office) => {
    createAndHit(office, ward, fiscal_year, projectType, projectTypeDCC, true)
    setOffice(office)
  }
  const fiscalYearSelected = (fiscal_year) => {
    createAndHit(office, ward, fiscal_year, projectType, projectTypeDCC, true)
    setFiscalYear(fiscal_year)
  }
  const wardSelected = (ward) => {
    createAndHit(office, ward, fiscal_year, projectType, projectTypeDCC, true)
    setWard(ward)
  }
  const projectTypeSelected = (projectType) => {
    createAndHit(office, ward, fiscal_year, projectType, projectTypeDCC, true)
    setProjectType(projectType)
  }
  const projectTypeSelectedDCC = (projectTypeDCC) => {
    createAndHit(office, ward, fiscal_year, projectType, projectTypeDCC, true)
    setProjectTypeDCC(projectTypeDCC)
  }
  const onChooseDisplay = (displayType) => {
    setChoosenDisplay(displayType)
  }
  if (fiscal_year === undefined && project_data === undefined && has_ever_hit_api === false) {
    createAndHit(office, ward, fiscal_year, undefined, undefined, false)
  }
  if (fiscal_year !== undefined && project_data === undefined && loading === false) {
    createAndHit(office, ward, fiscal_year, projectType, projectTypeDCC, true)
  }
  // for download icon
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;


  const handleChange = (event, value) => {
    setPage(value);
    window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
  };

  let projectPageList = []
  const ITEMS_PER_PAGE = 31

  if (project_data && project_data.length > 0) {
    let startingPoint = (page - 1) * ITEMS_PER_PAGE
    let endingPoint = ((project_data.length-1) < page * ITEMS_PER_PAGE) ? ((page*ITEMS_PER_PAGE) -  (page *ITEMS_PER_PAGE - (project_data.length))) : page *ITEMS_PER_PAGE
    for (var i = startingPoint; i < endingPoint; i++) {
      projectPageList.push(project_data[i])
    }
  }


  return (
    <div>
      <Header
        color="primary"
        routes={dashboardRoutes}
        brand=<Brand />
        shrink_brand=<Brand shrink={true} />
        rightLinks={<div><HeaderLinks /></div>}
        // fixed
        changeColorOnScroll={{
        // height: 70,
        // color: "primary",
      }}
      {...rest}
      />
      <div className={classNames(classes.main)}>
        {loading &&
          <div style={{ top: 0, left: 0, position: 'fixed', zIndex: 100, height: '100vh', width: '100%', backgroundColor: 'rgba(255,255,255,0.7)' }} >
            <CircularProgress style={{ color: '#134c7a', textAlign: 'center', marginTop: '23%', marginLeft: '45%' }} />
          </div>
        }
        <div style={{ backgroundColor: '#fff', minHeight: '70vh' }}>
          <GridContainer style={{ margin: 0 }}>
            <GridItem md={3} style={{ margin: 'auto', textAlign: 'center', marginTop: 0 }}>
              <h2>
                योजनाहरु
              </h2>
              <div>
                <Button color={choosenDisplay === "map" ? "primary" : ""} onClick={() => { onChooseDisplay("map") }}>नक्शामा</Button>
                <Button color={choosenDisplay === "table" ? "primary" : ""} onClick={() => { onChooseDisplay("table") }}>तालिकामा</Button>
              </div>
              <div>
                <span>
                  <h5>निकाय छान्नुहोस्:</h5>
                </span>
                <span>
                  <CustomDropdown
                    noLiPadding
                    buttonText=<span>{nameMap[office]}</span>
                      buttonProps={{
                  className: classes.navLink,
                  color: 'primary',
                  style: { width: '200px' }
                }}
                      dropdownList={
                  nameMapList.map(row => {
                    return (
                      <Button color="transparent" fullWidth onClick={() => officeSelected(row.value)}>
                        {row.name}
                      </Button>
                    );
                  })
                }
                      />

                </span>
              </div>

            <div>
            <span>
              <h5 style={{}}>आर्थिक वर्ष:</h5>
            </span>
            <span>
              <CustomDropdown
                noLiPadding
                buttonText=<span style={{ fontFamily: 'nepali-font' }}>{FISCAL_YEAR_STRING[fiscal_year]}</span>
                      buttonProps={{
              className: classes.navLink,
              color: 'primary',
              style: { width: '200px' }
            }}
                      dropdownList={
              project_data ? [...new Set(project_data.map(project_unit => project_unit.fiscal_year).filter(x => x))].map(row => {
                return (
                  <Button color="transparent" style={{ fontFamily: 'nepali-font' }} fullWidth onClick={() => fiscalYearSelected(row)}>
                    {FISCAL_YEAR_STRING[row]}
                  </Button>
                );
              })
                :
                []
            }
                    />
                </span>
        </div>

        {office !== "districtOffice" &&
          <div>
            <span>
              <h5 style={{}}>योजनाको प्रकार छान्नुहोस्:</h5>
            </span>
            <span>
              <CustomDropdown
                noLiPadding
                buttonText=<span style={{ fontFamily: 'nepali-font' }}>{projectTypeMap[projectType]}</span>
                      buttonProps={{
              className: classes.navLink,
              color: 'primary',
              style: { width: '200px' }
            }}
                      dropdownList={
              projectTypeMapList.map(row => {
                return (
                  <Button color="transparent" style={{ fontFamily: 'nepali-font' }} fullWidth onClick={() => projectTypeSelected(row.value)}>
                    {row.name}
                  </Button>
                );
              })
            }
                    />
                </span>
              </div>}
      {office === "districtOffice" &&
        <div>
          <span>
            <h4 style={{}}>योजनाको प्रकार छान्नुहोस्:</h4>
          </span>
          <span>
            <CustomDropdown
              noLiPadding
              buttonText=<span style={{ fontFamily: 'nepali-font' }}>{projectTypeMapDCC[projectTypeDCC]}</span>
                      buttonProps={{
            className: classes.navLink,
            color: 'primary',
            style: { width: '200px' }
          }}
                      dropdownList={
            projectTypeMapListDCC.map(row => {
              return (
                <Button color="transparent" style={{ fontFamily: 'nepali-font' }} fullWidth onClick={() => projectTypeSelectedDCC(row.value)}>
                  {row.name}
                </Button>
              );
            })
          }
                    />
                </span>
              </div>}

              {office !== "districtOffice" &&
                <div>
                  <span>
                    <h4 style={{}}>वडा छान्नुहोस्:</h4>
                  </span>
                  <span>
                    <CustomDropdown
                      noLiPadding
                      buttonText=<span style={{ fontFamily: 'nepali-font' }}>{wardsMap[ward]}</span>
                        buttonProps={{
                    className: classes.navLink,
                    color: 'primary',
                    style: { width: '200px' }
                  }}
                        dropdownList={
                    wardsMapList.map(row => {
                      return (
                        <Button color="transparent" style={{ fontFamily: 'nepali-font' }} fullWidth onClick={() => wardSelected(row.value)}>
                          {row.name}
                        </Button>
                      );
                    })
                  }
                      />
                  </span>
                </div>}


                <div style={{ paddingBottom: '50px' }}>

                  <div style={{ textAlign: 'left', width: '190px', margin: 'auto' }}>

                  {project_file && project_file.length > 0 &&
                  <div style={{ }}>
                    <h3>उपलब्ध फाईलहरू</h3>
                      {project_file.map(
                        file_object => {
                          return (
                            <a style={{backgroundColor: '#eee', color: '#333' }} fullWidth href={file_object.file} target="_blank">
                              <p data-tip={(file_object.name === '' || file_object.name === undefined|| file_object.name === null) ? 'फाइल' : file_object.name}>
                                <div style={{ width: '100%', clear: 'both' }}>
                                  <div style={{ float: 'left' }}>{(file_object.name === '' || file_object.name === undefined|| file_object.name === null) ? 'फाइल' : <Truncate lines={1} ellipsis={<span>...</span>}>{file_object.name}</Truncate>}</div>
                                  <div style={{ float: 'right', marginTop: '4px' }}><GetAppIcon style={{ color: "#134c7a" }} fontSize="small" /></div>
                                </div>
                              </p>
                              <ReactTooltip />
                            </a>
                          )
                        }
                      )}
                  </div>}

                  {choosenDisplay !== "map" &&
                  <div style={{ clear: 'both', marginTop: '50px' }}>
                    <h3>छोटो जानकारी</h3>
                    {project_data && project_data.length > 0 ?
                      <div style={{ width: '100%' }}>
                        <div>
                          जम्मा योजना संख्या: <span style={{ fontFamily: 'nepali-font' }}>{project_data.length}</span>
                        </div>
                        <div>
                          जम्मा बजेट: रु. <span style={{ fontFamily: 'nepali-font' }}>{cleanAndAdd(project_data.map(project_unit => office === 'districtOffice' ? project_unit.budget_amount : project_unit.amount))}</span>
                        </div>
                      </div>
                    :
                      <div md={6} style={{ marginTop: 0, width: '100%' }}>
                        <div>योजना उपलब्ध छैन</div>
                        <div>जम्मा योजना संख्या: <span style={{ fontFamily: 'nepali-font' }}>0</span></div>
                      </div>
                    }
                  </div>}


                  </div>
                </div>


            </GridItem >
  <GridItem md={9} style={{ padding: 0 }}>
    <div
      id="map"
      ref={el => mapContainer = el} //eslint-disable-line
      style={{ height: choosenDisplay === "map" ? '75vh' : 0, minHeight: choosenDisplay === "map" ? '400px' : 0, color: '#333' }}
    />
      {choosenDisplay === "map" && <div style={{ borderBottomLeftRadius: '100px',borderBottomRightRadius: '100px', marginBottom: '10px', backgroundColor: '#134c7a', fontSize: '24px', padding: '20px', height: '70px', textAlign: 'center', color: 'white'}}>
      {project_data && project_data.length > 0 ?
        <div style={{ width: '100%' }}>
          <div style={{ width: '34%', float: 'left' }}>
            {nameMap[office]} -
          </div>
          <div style={{ width: '33%', float: 'left' }}>
            जम्मा योजना संख्या: <span style={{ fontFamily: 'nepali-font' }}>{project_data.length}</span>
          </div>
          <div style={{ width: '33%', float: 'left' }}>
            जम्मा बजेट: रु. <span style={{ fontFamily: 'nepali-font' }}>{cleanAndAdd(project_data.map(project_unit => office === 'districtOffice' ? project_unit.budget_amount : project_unit.amount))}</span>
          </div>
        </div>
      :
        <div md={6} style={{ marginTop: 0, width: '100%' }}>
          <div style={{ width: '34%', float: 'left' }}>
            {nameMap[office]} -
          </div>
          <div style={{ width: '33%', float: 'left' }}>योजना उपलब्ध छैन</div>
          <div style={{ width: '33%', float: 'right' }}>जम्मा योजना संख्या: <span style={{ fontFamily: 'nepali-font' }}>0</span></div>
        </div>
      }

      </div>}
    {/*choosenDisplay === 'map' &&
      <div style={{ position: 'absolute', top: 0, right: 0, backgroundColor: 'rgba(255,255,255,0.7)', margin: '10px', border: '1px solid #ddd', borderRadius: '3px', padding: '10px' }}>
        {project_data && project_data.length > 0 && <div>
          <h5>जम्मा योजना संख्या: <span style={{ fontFamily: 'nepali-font' }}>{project_data.length}</span></h5>
          <h5>जम्मा बजेट: रु.<span style={{ fontFamily: 'nepali-font' }}>{cleanAndAdd(project_data.map(project_unit => office === 'districtOffice' ? project_unit.budget_amount : project_unit.amount))}</span></h5>
        </div>}
        {project_file && project_file.length>0 &&
        <div style={{ margin: 'auto', textAlign: 'center' }}>
          <div><IconButton
            aria-label="download"
            style={{ backgroundColor: "#eee" }}
            onClick={handleClick}
          >
            <GetAppIcon style={{ color: "#134c7a" }} fontSize="large" />
          </IconButton></div>
          फाइल डाउनलोड
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center"
            }}
          >
            {project_file.map(
              file_object => {
                return(
                  <ButtonMI color="transparent" fullWidth href={file_object.file} download target="_blank">
                    {(file_object.name === '' || file_object.name === undefined) ? 'फाइल' : file_object.name}
                  </ButtonMI>
                )
              }
            )}
          </Popover>

        </div>}


      </div>
    */}
    {choosenDisplay === 'table' &&
      <div style={{ margin: '10px' }}>
        {/*
          project_data && project_data.length > 0 &&
          <Card style={{ marginBottom: '5px' }}>
            <CardBody style={{ textAlign: 'center' }}>
              <GridContainer>
                <GridItem md={(project_file && project_file.length > 0) ? 4 : 6} sm={12} xs={12} >
                  <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#444' }}>जम्मा योजना संख्या: <span style={{ fontFamily: 'nepali-font', fontWeight: 'normal' }}>{project_data.length}</span></h3>
                </GridItem>
                <GridItem md={(project_file && project_file.length > 0) ? 4 : 6} sm={12} xs={12} >
                  <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#444' }}>जम्मा बजेट: रु. <span style={{ fontFamily: 'nepali-font', fontWeight: 'normal' }}>{cleanAndAdd(project_data.map(project_unit => office === 'districtOffice' ? project_unit.budget_amount : project_unit.amount))}</span></h3>
                </GridItem>
                {(project_file && project_file.length > 0) &&
                  <GridItem md={4} sm={12} xs={12}>
                    <div>
                      <div><IconButton
                        aria-label="download"
                        style={{ backgroundColor: "#eee" }}
                        href=""
                        download
                        size="small"
                        target="_blank"
                        onClick={handleClick}
                      >
                        <GetAppIcon style={{ color: "#134c7a" }} fontSize="medium" />
                      </IconButton></div>
                      फाइल डाउनलोड
                      <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center"
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center"
                        }}
                      >
                      {project_file.map(
                        file_object => {
                          return(
                            <ButtonMI color="transparent" fullWidth href={file_object.file} download target="_blank">
                              {(file_object.name === '' || file_object.name === undefined) ? 'फाइल' : file_object.name}
                            </ButtonMI>
                          )
                        }
                      )}
                      </Popover>

                    </div>
                  </GridItem>
                }

              </GridContainer>
            </CardBody>
          </Card>
        */}
        {
          project_data && project_data.length === 0 && office === 'districtOffice' &&
          <Card>
            <CardBody style={{ textAlign: 'center' }}>
              <h3>उपलब्ध छैन</h3>
            </CardBody>
          </Card>
        }
        {
          project_data && project_data.length === 0 && office !== 'districtOffice' &&
          <Card style={{ marginBottom: '-5px' }}>
            <CardBody style={{ textAlign: 'center' }}>
              <h3>उपलब्ध छैन</h3>
            </CardBody>
          </Card>
        }
          {projectPageList.length > 0 && office === 'districtOffice' &&
            <table style={{ width: '95%', marginTop: '50px', borderCollapse: 'collapse' }} className="projecttable">
              <tr style={{textAlign: 'center', backgroundColor: '#c5d7e5'}}>
                <th style={{width: '30%', paddingTop: '10px', paddingBottom: '10px', margin: 0}}>प्रतिनिधि</th>
                <th style={{width: '55%', paddingTop: '10px', paddingBottom: '10px', margin: 0}}>योजना</th>
                <th style={{width: '15%', paddingTop: '10px', paddingBottom: '10px', margin: 0}}>बजेट</th>
              </tr>
            {/*<tr style={{textAlign: 'center'}}>
              <th style={{width: '30%', paddingTop: '10px', paddingBottom: '10px', border: '1px solid #aaa', margin: 0}}>प्रतिनिधि</th>
              <th style={{width: '30%', paddingTop: '10px', paddingBottom: '10px', border: '1px solid #aaa', margin: 0}}>योजना</th>
              <th style={{width: '10%', paddingTop: '10px', paddingBottom: '10px', border: '1px solid #aaa', margin: 0}}>बजेट</th>
              <th style={{width: '20%', paddingTop: '10px', paddingBottom: '10px', border: '1px solid #aaa', margin: 0}}>सम्बन्धित नगरपालिका/निकाय</th>
              <th style={{width: '10%', paddingTop: '10px', paddingBottom: '10px', border: '1px solid #aaa', margin: 0}}>सम्बन्धित वडा(हरु)</th>
            </tr>*/}{
            projectPageList.map(
              (project_unit, idx) => {
                // return (
                //   <tr>
                //     <td style={{ width: '30%', textAlign: 'center', border: '1px solid #aaa', padding: '10px' }}>
                //       {idx === 0 ? project_unit.category : (projectPageList[idx-1].category === project_unit.category ? <h3>``</h3> : project_unit.category)}
                //     </td>
                //     <td style={{ width: '30%', border: '1px solid #aaa', padding: '10px' }}>{project_unit.title}</td>
                //     <td style={{ width: '10%', textAlign: 'center', border: '1px solid #aaa', padding: '10px' }}>रु. <span style={{ fontFamily: 'nepali-font' }}>{project_unit.budget_amount}</span></td>
                //     <td style={{ width: '20%', textAlign: 'center', border: '1px solid #aaa', padding: '10px' }}>{ADMIN_MAP[project_unit.related_municipality]}</td>
                //     <td style={{ width: '10%', textAlign: 'center', border: '1px solid #aaa', padding: '10px', fontFamily: 'nepali-font' }}>{project_unit.related_wards}</td>
                //   </tr>
                // )
                return (
                  <tr style={{ }}>
                    <td style={{ width: '30%', textAlign: 'center', padding: '10px', fontWeight: 'bold' }}>
                      {idx === 0 ? project_unit.category : (projectPageList[idx-1].category === project_unit.category ? <h3></h3> : project_unit.category)}
                    </td>
                    <td style={{ width: '55%', padding: '10px' }}>
                      {project_unit.title}{ADMIN_MAP[project_unit.related_municipality] !== null && ADMIN_MAP[project_unit.related_municipality] !== undefined && ADMIN_MAP[project_unit.related_municipality] !== '' ? ` - ${ADMIN_MAP[project_unit.related_municipality]}` : ''}{project_unit.related_wards !== null && project_unit.related_wards !== undefined && project_unit.related_wards !== '' ? <span>, वडा नं. <span style={{ fontFamily: 'nepali-font' }}>{project_unit.related_wards}</span></span> : ''}
                    </td>
                    <td style={{ width: '15%', textAlign: 'center', padding: '10px' }}>रु. <span style={{ fontFamily: 'nepali-font' }}>{project_unit.budget_amount}</span></td>
                  </tr>
                )
              }
            )}
            </table>
          }
        {projectPageList.length > 0 && office !== 'districtOffice' &&
        <table style={{ width: '100%', marginTop: '50px' }} className="projecttable">
        <tr style={{textAlign: 'center', backgroundColor: '#c5d7e5'}}>
        <th style={{width: '40%', paddingTop: '10px', paddingBottom: '10px', margin: 0}}>योजना</th>
        <th style={{width: '20%', paddingTop: '10px', paddingBottom: '10px', margin: 0}}>बजेट</th>
        <th style={{width: '20%', paddingTop: '10px', paddingBottom: '10px', margin: 0}}>वडा नं.</th>
        <th style={{width: '20%', paddingTop: '10px', paddingBottom: '10px', margin: 0}}>उप शीर्षक</th>
        </tr>
        {
          projectPageList.map(
            (project_unit) => {
              return (
                <tr>
                  <td style={{ width: '40%', padding: '10px' }}>{project_unit.title}</td>
                  <td style={{ width: '20%', textAlign: 'center', padding: '10px' }}>रु. <span style={{ fontFamily: 'nepali-font' }}>{project_unit.amount}</span></td>
                  <td style={{ width: '20%', textAlign: 'center', padding: '10px', fontFamily: 'nepali-font' }}>{project_unit.ward !== '' && `${wardsMap[project_unit.ward]}`}</td>
                  <td style={{ width: '20%', textAlign: 'center', padding: '10px' }}>
                    {`${MUNICIPALITY_PROJECT_CATEGORY_MAP[project_unit.category]}`}
                  </td>
                </tr>
              )
            }
          )
        }
        </table>}

        {project_data && project_data.length > 0 &&
          <GridContainer style={{ margin:0, padding:0 }}>
            <GridItem md={4}/>
            <GridItem md={5}style={{ marginTop: '50px', marginBottom: '50px' }}>
              <Pagination style={{margin: 'auto', padding:'auto', textAlign: 'center'}} count={parseInt(project_data.length / ITEMS_PER_PAGE) + ((project_data.length % ITEMS_PER_PAGE) > 0 ? 1:0)} page={page} onChange={handleChange} />
            </GridItem>
            <GridItem md={3}/>
          </GridContainer>
        }


      </div>}
  </GridItem>

          </GridContainer >

  <div className={classes.container} >
    {/*<ProjectInsight />*/}
  </div>
        </div >
{/*selectedMunicipality === undefined &&
          <div className={classes.container} >
            <Municipality page="project" />
          </div>
        */}
      </div >
  <Footer />
    </div >
  );
}
